module.exports = __webpack_public_path__ + "img/br.233d308c.svg";